type Vec3 = [number, number, number];

export const centroid = (vectors: Vec3[]): Vec3 => {
    const sum: Vec3 = [0, 0, 0];
    for (const v of vectors) {
        sum[0] += v[0];
        sum[1] += v[1];
        sum[2] += v[2];
    }
    const n = vectors.length;
    return [sum[0] / n, sum[1] / n, sum[2] / n];
};

export const directionTo = (start: Vec3, end: Vec3): Vec3 => {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const dz = end[2] - start[2];
    const len = Math.sqrt(dx * dx + dy * dy + dz * dz);
    if (len === 0) return [0, 0, 0];
    return [dx / len, dy / len, dz / len];
};

export const dot = (a: Vec3, b: Vec3): number =>
    a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
